var _rect, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 24,
    fill: "#F1E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M25.2287 15.4283C26.9436 14.4127 29.0564 14.4127 30.7713 15.4283L37.2287 19.2524C38.9436 20.2679 40 22.1448 40 24.1759V31.8241C40 33.8552 38.9436 35.732 37.2287 36.7475L30.7713 40.5716C29.0564 41.5872 26.9436 41.5872 25.2287 40.5716L18.7713 36.7475C17.0564 35.732 16 33.8552 16 31.8241V24.1759C16 22.1448 17.0564 20.2679 18.7713 19.2524L25.2287 15.4283Z",
    fill: "#1C0054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2287 40.5715C26.9436 41.587 29.0564 41.587 30.7713 40.5715L36.4014 37.2373C34.7242 34.264 31.5898 32.2637 28 32.2637C24.4102 32.2637 21.2758 34.264 19.5986 37.2373L25.2287 40.5715Z",
    fill: "#1C0054"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    transform: "matrix(1 0 0 -1 24 29.3333)",
    fill: "#1C0054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminType);
export default __webpack_public_path__ + "static/media/admin-type.82c847473fc3e723ba2e3af24b3d7cc0.svg";
export { ForwardRef as ReactComponent };